(function(){
  "use strict";

  function initCarousel(root){
    var track = root.querySelector("[data-car-track]");
    var dotsWrap = root.querySelector("[data-car-dots]");
    var prev = root.querySelector("[data-car-prev]");
    var next = root.querySelector("[data-car-next]");
    if(!track) return;

    var slides = Array.prototype.slice.call(track.children);
    if(!slides.length) return;

    var index = 0;
    var maxIndex = 0;

    function stride(){
      if(slides.length < 2) return slides[0].offsetWidth;
      return slides[1].offsetLeft - slides[0].offsetLeft;
    }
    function perView(){
      var s = stride();
      if(!s) return 1;
      return Math.max(1, Math.round(track.clientWidth / s));
    }
    function smooth(){
      return window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
    }
    function goTo(i, behavior){
      index = Math.max(0, Math.min(i, maxIndex));
      track.scrollTo({ left: index * stride(), behavior: behavior || smooth() });
      syncDots();
    }
    function currentIndex(){
      var s = stride();
      return s ? Math.round(track.scrollLeft / s) : 0;
    }
    function syncDots(){
      var dots = dotsWrap ? dotsWrap.children : [];
      for(var i = 0; i < dots.length; i++){
        dots[i].setAttribute("aria-current", i === index ? "true" : "false");
      }
    }
    function buildDots(){
      if(!dotsWrap) return;
      dotsWrap.innerHTML = "";
      for(var i = 0; i <= maxIndex; i++){
        (function(i){
          var b = document.createElement("button");
          b.type = "button";
          b.className = "car-dot";
          b.setAttribute("aria-label", "Go to review " + (i + 1));
          b.addEventListener("click", function(){ goTo(i); });
          dotsWrap.appendChild(b);
        })(i);
      }
      syncDots();
    }
    function measure(){
      maxIndex = Math.max(0, slides.length - perView());
      if(index > maxIndex) index = maxIndex;
      buildDots();
    }

    if(next) next.addEventListener("click", function(){
      goTo(index >= maxIndex ? 0 : index + 1);          /* loops back to the start */
    });
    if(prev) prev.addEventListener("click", function(){
      goTo(index <= 0 ? maxIndex : index - 1);          /* loops around to the end */
    });

    var scrollTimer;
    track.addEventListener("scroll", function(){
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function(){
        index = Math.max(0, Math.min(currentIndex(), maxIndex));
        syncDots();
      }, 90);
    });

    /* drag-to-scroll (mouse / pen); touch uses native scrolling */
    var dragging = false, startX = 0, startLeft = 0, moved = 0;
    track.addEventListener("pointerdown", function(e){
      if(e.pointerType === "touch") return;
      dragging = true; moved = 0;
      startX = e.clientX; startLeft = track.scrollLeft;
      track.classList.add("is-dragging");
    });
    track.addEventListener("pointermove", function(e){
      if(!dragging) return;
      var dx = e.clientX - startX;
      moved = Math.abs(dx);
      track.scrollLeft = startLeft - dx;
    });
    function endDrag(){
      if(!dragging) return;
      dragging = false;
      track.classList.remove("is-dragging");
      goTo(currentIndex());
    }
    track.addEventListener("pointerup", endDrag);
    track.addEventListener("pointercancel", endDrag);
    track.addEventListener("pointerleave", endDrag);
    track.addEventListener("click", function(e){
      if(moved > 6){ e.preventDefault(); e.stopPropagation(); }
    }, true);

    var resizeTimer;
    window.addEventListener("resize", function(){
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(measure, 150);
    });

    measure();
  }

  function initAll(){
    var roots = document.querySelectorAll("[data-carousel]");
    for(var i = 0; i < roots.length; i++){ initCarousel(roots[i]); }
  }

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
